import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TitleService {

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private title: Title,
    private translate: TranslateService
  ) { }

  public bindTitleChanges() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activeRoute)
      .map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data)
      .subscribe(event => {
        const title = this.translate.instant(event['title']);
        this.title.setTitle(title);
      });
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/title.service.ts